const fs = require('fs')
const yaml = require('js-yaml')
const setting = require('./setting')

module.exports.updateConfig = () => {
  return new Promise((resolve, reject) => {
    if (fs.existsSync(setting.configPath)) {
      fs.readFile(setting.configPath, {}, (error, data) => {
        if (error) {
          reject(error)
        } else {
          const config = yaml.safeLoad(data)
          resolve(config)
        }
      })
    }
  })
}
